import ApproveProcedureFileManagement from "../../../../procedureFileSections/fields/procedureFileManagementFields/approveProcedureFileManagement";

export default class ApproveSupportingFileManagement extends ApproveProcedureFileManagement {}
